import React from 'react';
import { NavLink, withRouter } from 'react-router-dom'
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { footerHeight } from '../Footer/Footer';
import { toolbarheight } from '../../theme';
import Button from '@material-ui/core/Button'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';

const sidebarWidth = "16em";

const useStyles = makeStyles((theme) => ({
    heading4: {
        fontSize: "1.25em",
        fontWeight: 400,
        color: "#fff",
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: "5px"
    },
    icons: {
        fontSize: "0.8em",
        color: "#fff",
    },
    icondiv: {
        borderBottom: "1px solid #404854",
        width: "100%"
    },
    adminsidebar: {
        minHeight: `calc(99.8vh - 8vh - ${toolbarheight} - ${footerHeight})`,
        paddingTop: toolbarheight,
        width: sidebarWidth,
        overflow: "auto",
        backgroundColor: "#262f3e",
        borderLeft: "1px solid #404854",
        '& button': {
            textTransform: 'none',
            width : "100%",
            fontSize : "1em",
            padding: ".25em",
            marginLeft: "4px",
            height : "64px",
            '&:hover' : {
                color : "#4fc3f7",
                textDecoration : "none"
            },
            '&:first-child': {
                borderTop: "1px solid #404854"
            },
            '&:last-child': {
                borderBottom: "none",
            },
            '& a': {
                padding: ".25em",
                height: "64px",
                '&:hover': {
                    color: "#4fc3f7",
                    textDecoration: "none"
                }
            },
            "& p": {
                margin: "0px 0px 0px 0px",
                paddingLeft: "3.5em",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
            }
        },
        '& nav': {
            width: "100%",
            fontSize: "0.8em",
            color: "rgba(255, 255, 255, 0.2)",
            borderBottom: "1px solid #404854",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            '&:hover': {
                backgroundColor: "#263238"
            },
            '&:first-child': {
                borderTop: "1px solid #404854",
            },
            '&:last-child': {
                borderBottom: "none",
            },
            '& a': {
                padding: ".25em",
                height: "64px",
                '&:hover': {
                    color: "#4fc3f7",
                    textDecoration: "none"
                }
            },
            "& p": {
                margin: "0px 0px 0px 0px",
                paddingLeft: "3.5em",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
            }
        },
        '&::-webkit-scrollbar': {
            width: '0.5em'
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
            webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'grey',
            outline: '1px solid slategrey'
        }
    },
    open: {
        backgroundColor: "#19212b",
    },
    list: {
        paddingTop: "0px",
        paddingBottom: "0px"
    },
    listIcon: {
        marginLeft: "4px",
        minWidth: "36px"
    },
    active: {
        backgroundColor: "#35465b"
    },
    asideOpen: {
        width: sidebarWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
    },
    asideClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: 'hidden',
        width: `calc(${sidebarWidth}*.20)`,
    },
    nested: {
        fontSize: "0.5em",
        marginLeft: "3.5em"
    }
}));

const ReportsSidebar = (props) => {
    const { sidebarItems, SelectReport } = props;
    const classes = useStyles();
    const [activeMenu, setActiveMenu] = React.useState(-1);
    const [menuOpen, setmenuOpen] = React.useState(-1);
    const handleClick = (e) => {
        SelectReport(Number(e.currentTarget.dataset.id));
        setmenuOpen(Number(e.currentTarget.dataset.id));
        setActiveMenu(Number(e.currentTarget.dataset.id));
    }
    return (
        <aside className={classes.adminsidebar}>
            <div className={classes.heading4}>Reports</div>
            {sidebarItems?.map((item, index) => (
                <nav key={item.id} >
                    <List className={classes.list}>
                        <ListItem
                            name={item.ItemName}
                            data-id={item.id}
                            key={item.id}
                            component={Button}
                            //to={`${item.link}`}
                            className={ activeMenu === item.id ? clsx(classes.heading4, classes.active, classes.open) : classes.heading4}
                            onClick={(e) => handleClick(e)}
                        >
                            <ListItemText disableTypography primary={item.ItemName} />
                        </ListItem>
                    </List>
                </nav>
            ))}

        </aside>
    );
};

export default withRouter(ReportsSidebar);